var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-4"},[_c('CardProducto',{attrs:{"titulo":_vm.oferta.nombreCompleto,"rutaInferior":_vm.rutaInferior,"imageSrc":_vm.imageSrc,"precio":_vm.precio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }